export var getSocialMediaLinks = function getSocialMediaLinks(socialMedia) {
  var getIconName = function getIconName(title) {
    if (title === 'Twitter') {
      return 'SocialX';
    }

    return "Social".concat(title);
  };

  return socialMedia.map(function (link) {
    var title = (link === null || link === void 0 ? void 0 : link.title) === 'LinkedIn' ? 'Linkedin' : link === null || link === void 0 ? void 0 : link.title;
    return {
      href: link === null || link === void 0 ? void 0 : link.path,
      icon: getIconName(title),
      label: title || ''
    };
  });
};